export class BOHealthTechnologyTerm{
    id:number;
    quantity:number;
    timeUnit:string;
}